const servicesList = {
	initialConsultation: {
		id: 1,
		icon: "fa-solid fa-comments",
		title: "Initial Consultation",
		// href: "https://trustedcounselingconsulting.janeapp.com/#/staff_member/1/treatment/6",
		href: "/contact",
		duration: "20 minutes",
		pricing: "30",
		text: "An introductory session to discuss your needs and determine the best tailored solution for you.",
		serviceDetails: {
			serviceName: "Initial Consultation",
			serviceDetails:
				"The initial consultation provides an opportunity for clients to discuss their concerns and goals with a therapist. This session helps in understanding the client's needs and setting the foundation for future therapy.",
			howItWorks:
				"During the consultation, clients will share their background and what they hope to achieve. The therapist will provide insights and recommendations for the best therapeutic approach moving forward.",
			otherInfo: "This session can be conducted in-person or online.",
			keyPoints: [
				"Understanding your needs and goals.",
				"Setting a personalized therapy plan.",
				"Opportunity to ask questions about the therapy process.",
			],
		},
	},
	individualCounseling: {
		id: 2,
		icon: "fa-solid fa-user",
		title: "Individual Counseling",
		// href: "https://trustedcounselingconsulting.janeapp.com/#/staff_member/1/treatment/3",
		href: "/contact",
		duration: "50 minutes",
		pricing: "150",
		text: "Personalized therapy sessions focused on individual mental health challenges and solutions.",
		serviceDetails: {
			serviceName: "Individual Counseling",
			serviceDetails:
				"Individual counseling provides a safe, confidential space where clients can work through personal challenges. The therapy is tailored to each individual's unique needs, helping them gain clarity, emotional support, and practical coping strategies.",
			howItWorks:
				"Through one-on-one sessions, clients will explore their feelings, triggers, and life experiences. Various therapeutic techniques, including Cognitive Behavioral Therapy (CBT) and Solution-Focused Therapy, will be used to help them achieve their mental health goals.",
			otherInfo: "This session can be conducted in-person or online.",
			keyPoints: [
				"Personalized attention and care.",
				"Effective tools to manage anxiety, depression, and trauma.",
				"Empowerment through a better understanding of personal challenges.",
			],
		},
	},
	couplesCounseling: {
		id: 3,
		icon: "fa-solid fa-heart",
		title: "Couples Counseling",
		// href: "https://trustedcounselingconsulting.janeapp.com/#/staff_member/1/treatment/5",
		href: "/contact",
		duration: "80 minutes",
		pricing: "180",
		text: "Therapy sessions designed to improve communication and resolve conflicts in relationships.",
		serviceDetails: {
			serviceName: "Couples Counseling",
			serviceDetails:
				"Couples counseling addresses a range of relationship concerns such as communication issues, marital struggles, and family conflict. This service helps couples build healthier relationships and resolve underlying issues.",
			howItWorks:
				"Sessions typically involve both partners discussing their concerns, while the therapist provides guidance on improving communication, setting boundaries, and finding solutions. The Gottman Method, among other approaches, is often used to promote understanding and connection.",
			otherInfo: "This session can be conducted in-person or online.",
			keyPoints: [
				"Strengthens communication and trust in relationships.",
				"Provides tools for conflict resolution.",
				"Helps rebuild emotional connection and intimacy.",
			],
		},
	},
};

export default servicesList;
